/**
 * Core InfluxDB helpers shared across modules.
 */
import { supabase } from "@/integrations/supabase/client";

export interface InfluxDataValue {
  value: number | string | null;
  timestamp: string | null;
}

export async function fetchCurrentValues(
  mappingIds: string[]
): Promise<Record<string, InfluxDataValue>> {
  if (mappingIds.length === 0) return {};

  const { data, error } = await supabase.functions.invoke("influxdb-query", {
    body: { mapping_ids: mappingIds },
  });

  if (error) throw error;
  return data?.data ?? {};
}
